import { SET_CERTIFICATE_DATA, SET_CERTIFIED_DATA, SET_EDIT_STATUS, SET_LOCK_STATUS, SET_REQUEST_CV_STATUS, SET_REQUEST_INTERVIEW_STATUS, SET_RESET_DATA, SET_USER_CV_DATA, SET_USER_ENGAGEMENT_DATA, SET_USER_FORM_DATA, SET_USER_LINKEDIN_URL, SET_USER_TYPE } from "../actions/types";


const initialState = {
   userInfo : {
    name :"",
    email : "",
    role : "",
    role_data : "",
    role_headings :"",
    phone_number : ""
   },
   user_linked_url : "",
   user_type: "",
   is_locked: true,
   is_edit: false,
   certificateData : {},
   engagements : {},
   cvData:{},
   is_interview_requested : false,
   is_cv_requested : false
};



// eslint-disable-next-line import/no-anonymous-default-export
export default function (state = initialState, action) {
    switch (action.type) {
        case SET_USER_FORM_DATA:
            return {
                ...state,
                userInfo: action.payload
            }
        case SET_USER_TYPE:
            return {
                ...state,
                userType: action.payload
            }
        case SET_USER_LINKEDIN_URL:{
            return {
                ...state,
                user_linked_url : action.payload
            }
        }
        case SET_LOCK_STATUS : {
            return {
                ...state , 
                is_locked : action.payload
            }
        }
        case SET_CERTIFICATE_DATA : {
            return {
                ...state ,
                certificateData : action.payload
            }
        }
        case SET_USER_ENGAGEMENT_DATA : {
            return {
                ...state , 
                engagements : action.payload
            }
        }
        case SET_EDIT_STATUS:{
            return {
                ...state,
                is_edit : action.payload
            }
        }
        case SET_USER_CV_DATA:{
            return {
                ...state,
                cvData : action.payload
            }
        }
        case SET_CERTIFIED_DATA : {
            return {
                ...state,
                certifiedData : action.payload
            }
        }
        case SET_REQUEST_CV_STATUS :{
            return {
                ...state , 
                is_cv_requested : action.payload
            }
        }
         case SET_REQUEST_INTERVIEW_STATUS :{
            return {
                ...state , 
                is_interview_requested : action.payload
            }
        }
         case SET_RESET_DATA: {
            return action.payload
            
         }
        
        default:
            return state;
    }
}